module.exports = __webpack_public_path__ + "media/promo/courses/images/case-065295eaba3395c0f4f7e245f398a5ba.jpg";